<script>
import BaseView from "@/mixins/BaseView.vue";
import TrucksList from "@/views/trucks/components/TrucksList.vue";
import TrucksSearchForm from "@/views/trucks/components/TrucksSearchForm.vue";
import PageHeader from "@/components/header/PageHeader.vue";

export default {
  name: "TrucksPage",
  components: { PageHeader, TrucksSearchForm, TrucksList },
  mixins: [BaseView],
  data() {
    return {
      perm: "trucks",
      searchParams: {},
      errorData: null,
    };
  },
  created() {
    this.setTitle(this.$t("trucks.search"));
  },
  methods: {
    search(params) {
      this.searchParams = { ...params };
    },
    handleError(errorData) {
      if (!errorData) {
        this.errorData = null;

        return;
      }

      this.errorData = errorData.reduce((acc, el) => {
        if (el.loc) {
          acc[el.loc[0]] = el.msg;
        }

        return acc;
      }, {});
    },
  },
};
</script>

<template>
  <v-container :fluid="true" class="pt-6 pb-10 pl-6 pr-6 height-100 trucks-search">
    <page-header :header="$t('trucks.search')"></page-header>
    <trucks-search-form :error-data="errorData" @search="search" />
    <trucks-list
      :available-columns="['name', 'status', 'size', 'contact', 'distance', 'available', 'notes']"
      :search-params="searchParams"
      @handle-error="handleError"
    />
  </v-container>
</template>

<style lang="scss" scoped>
.trucks-search {
  & > .v-card {
    background: transparent;
  }

  .col-status {
    .quote-btn {
      // dont show notes for status column in truck search
      display: none;
    }
  }

  .location-btn {
    display: block;
  }
}
</style>
